<div class="home-container">
  <h2 i18n>My Overview</h2>
  <mat-grid-list [cols]="totalCols" rowHeight="100px" (window:resize)="onResize($event)">
    <mat-grid-tile [colspan]="profileCols" [rowspan]="profileRows">
      <mat-card class="card profile-card">
        <mat-card-content>
          <p i18n   class="mat-card-header">MY PROFILE</p>
          <div class="avatar">
            <img [src]="avatar_url" alt="avatar">
          </div>
          <div class="infos">
            <mat-form-field class="full-width">
              <mat-label i18n i18n class="label">First name</mat-label>
              <input matInput [value]="userInfo.firstName" disabled>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label i18n class="label">Last name</mat-label>
              <input matInput [value]="userInfo.lastName" disabled>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label i18n class="label">Email</mat-label>
              <input matInput [value]="userInfo.email" disabled>
            </mat-form-field>
          </div>
          <a i18n [routerLink]="['/dashboard/profile']" routerLinkActive="router-link-active" class="edit-profile">Edit
            profile <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon></a>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="orderCols" [rowspan]="orderRows">
      <mat-card class="card order-card">
        <mat-card-content>
          <p i18n  class="mat-card-header">MY ORDERS</p>
          <div class="table-container">
            <ng-container class="mat-elevation-z8 order-table">
              <div class="column-container title-column-container">
                <th class="title-column" i18n>Date</th>
                <th class="title-column" i18n>#</th>
                <th class="title-column" i18n>Total</th>
                <th class="title-column" i18n>Status</th>
                <th class="title-column" i18n></th>
              </div>
              <div  *ngFor="let item of orders" >
                <div class="column-container">
                  <th>{{item.created_date | date:'yyyy-MM-dd HH:mm'}}</th>
                  <th>{{item.id}}</th>
                  <th><app-currency-converter [data]="{price:item.totalPrice, country: null}"></app-currency-converter></th>
                  <th i18n *ngIf="item.status_id == 0">Placed</th>
                  <th i18n *ngIf="item.status_id == 1">Confirmed</th>
                  <th i18n *ngIf="item.status_id == 2">In Progress</th>
                  <th i18n *ngIf="item.status_id == 3">Shipped</th>
                  <th i18n *ngIf="item.status_id == 4">Delivered</th>
                  <th class="status-container"> </th>
                </div>
              </div >
            </ng-container>
          </div>
          <p i18n  class="no-order" *ngIf="orderLength == 0">No order yet</p>

          <div class="button-container">
            <button i18n class="" *ngIf="orderLength != 0" routerLink="/dashboard/selection">Make new tree</button>
            <button i18n class="" *ngIf="orderLength != 0" routerLink="/dashboard/orders">View all orders</button>
          </div>
          
          <div class="new-order-group">
            <button i18n class="new-order" *ngIf="orderLength == 0" routerLink="/dashboard/selection">START CREATING MY
              TREE</button>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="newsCols" [rowspan]="newsRows">
      <mat-card class="card news-card">
        <mat-card-content>
          <p i18n  class="mat-card-header">NEWS</p>
          <div class="news-content">
            <div class="news-container">
              <div class="news-item">
                <div class="newsimage-container">
                  <img src=".\assets\image\news\christmasNews.png" alt="news" class="news-image">
                </div>
                <p i18n  class="news-title">Christmas gift from us to you! 🎁 </p>
                <div class="news-description"> 
                  <p i18n>Treat yourself or surprise someone you love with a memorable gift in the form of a unique family tree. Use discount code 
                    <span style="font-weight: bold">SANTA30</span> 
                    when placing your order to automatically get a 30% discount. But it gets even better! We also offer free express delivery for faster shipping. 🚚
                  </p>
                  <p i18n>Create your unique family tree today and take advantage of this exclusive Christmas discount! 🎄</p>
                  <p i18n>*The offer is valid until December 31 for one purchase and cannot be combined with other discounts.</p>
              </div>
              </div>
              <p i18n  class="read-more" routerLink="/dashboard/news">Read more <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
              </p>
            </div>
            <div class="news-container">
              <div class="news-item">
                <div class="newsimage-container">
                  <img src=".\assets\image\news\newrelease.nov.png" alt="news" class="news-image">
                </div>
                  <p i18n  class="news-title">New Features in Ancytree</p>
                  <div class="news-description"><p i18n>Explore the latest enhancements in Ancytree! We have now implemented price display in more currencies for a smoother experience. 
                    Klarna is now available in several countries as a payment option for easy and secure transaction management. 
                    Discover our new assistance packages that give you even more control over creating your family tree. 
                    Sign up for a shared digital session and get an overview of Ancytree, learn to create your profile, and upload your GEDCOM file. Ask questions and get answers instantly! 
                    We also offer other packages to help you create your family tree or receive personal guidance. 
                    Take a look today and start exploring Ancytree!
                  </p>
                  <p i18n>Additionally, we are excited to announce that we now offer delivery to all EU countries. We have also expanded our service to include different provinces/states in the USA and Canada. This means that even more people can take advantage of our fantastic offers.</p>
                  <p i18n>Don't miss the opportunity - order your assistance package today!</p>
                </div>
              </div>
              <p i18n  class="read-more" routerLink="/dashboard/news">Read more <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
              </p>
            </div>
            
          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="otherCols" [rowspan]="otherRows">
      <mat-card class="card design-card">
        <mat-card-content>
          <p i18n  class="mat-card-header">MY DESIGN</p>
          <div class="design" *ngIf="designs">
            <!-- <p i18n  class="text-2" style="margin-bottom:0px;"></p> -->
            <p i18n  class="text-3" style="font-weight: bold;">Your latest design:</p>
            <p i18n  *ngFor="let design of designs | slice:0:4;" style="text-align: left;" class="text-2 file-name">
              <span (click)="goToDesign(design.data,design.id)">{{design.data.design_name}} {{design.data.saved.toDate()
                |
                date}}</span>
            </p>
            <p i18n  class="upload-more" routerLink="/dashboard/designs">View more <mat-icon class="arrow-icon">
                keyboard_arrow_right</mat-icon>
            </p>
          </div>

          <div class="no-design" *ngIf="!designs">
            <div class="no-design-container">
              <p i18n  class="no-text-1">
                You have not started your tree / design.
              </p>
              <button i18n class="create-btn" routerLink="/dashboard/selection">Start creating now</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="otherCols" [rowspan]="otherRows">
      <mat-card class="card gedcom-card">
        <mat-card-content>
          <p i18n  class="mat-card-header">MY GEDCOM</p>
          <div class="gedcom-content" *ngIf="gedcoms?.length > 0">
            <div class="gedcom-description">
              <p i18n  class="text-3" style="font-weight: bold;" *ngIf="!gedcoms?.length > 1">Your latest GEDCOM file</p>
              <p i18n  class="text-3" style="font-weight: bold;">Your latest GEDCOM files:</p>
              <p i18n  *ngFor="let gedcom of gedcoms | slice:0:4;" class="text-2"><span class="file-name">{{gedcom.filename}}</span>
                {{gedcom.uploaded | date}}</p>
            </div>
            <p i18n  class="upload-more" routerLink="/dashboard/gedcom">Upload more <mat-icon class="arrow-icon">
                keyboard_arrow_right</mat-icon>
            </p>
          </div>

          <div class="gedcom-content" *ngIf="gedcoms?.length == 0">
            <div class="no-gedcom-container">
              <p i18n  class="no-text-1">
                No file uploaded
              </p>
              <button i18n class="create-btn" routerLink="/dashboard/gedcom">Upload my GEDCOM</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="otherCols" [rowspan]="otherRows">
      <mat-card class="card help-card">
        <mat-card-content>
          <p i18n  class="mat-card-header">NEED HELP?</p>
          <div class="help-content">
            <p i18n  class="text-1">YOU HAVE QUESTIONS.</p>
            <p i18n  class="text-1">WE HAVE ANSWERS.</p>
            <p >
              <span i18n class="text-2">Check out our helpful </span>
              <a i18n href="https://www.youtube.com/@Ancytree" target=”_blank” class="contact-us">videos on Youtube </a>
              <span i18n class="text-2">or for frequently asked questions, check out our </span>
              <a i18n href="https://ancytree.com/kundservice/" target=”_blank” class="contact-us">FAQ </a>
              <span i18n class="text-2">page. </span>
              <span i18n class="text-2">If you don't find answer to your question, you always are welcome to </span>
              <a i18n href="https://ancytree.com/kontakta-oss/" target=”_blank” class="contact-us">contact us. </a>
            </p>
          </div>
          <!-- <a i18n class="go-support" href="https://ancytree.com/support/" target=”_blank”>Create a case for customer service<mat-icon class="arrow-icon">
              keyboard_arrow_right</mat-icon>
          </a> -->
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>